import { useState, useRef, useEffect } from "react";
import { Globe as GlobeIcon, Check } from "lucide-react";
import { useI18n } from "../lib/i18n";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const select = (code) => {
    setLang(code);
    setOpen(false);
  };

  const activeLang = languages.find((l) => l.code === lang) || { code: lang };
  const display = (activeLang.code || "en").toUpperCase();

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 text-[13px] tracking-wide text-bone hover:text-teal transition px-2 py-1.5 rounded-full"
        data-testid="lang-switcher"
        aria-label="Change language"
      >
        <GlobeIcon size={14} />
        <span>{display}</span>
      </button>
      {open && languages.length > 0 && (
        <div className="absolute right-0 top-full mt-2 w-52 glass-solid rounded-2xl p-1.5 z-50 shadow-ink" data-testid="lang-menu">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => select(l.code)}
              className={`w-full flex items-center justify-between text-left px-3 py-2 rounded-xl text-sm hover:bg-white/5 ${lang === l.code ? "text-teal" : "text-bone"}`}
              data-testid={`lang-${l.code}`}
            >
              <span>
                <span className="font-medium mr-2 uppercase">{l.code}</span>
                <span className="text-muted text-[12px]">{l.native_name || l.name}</span>
              </span>
              {lang === l.code && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export { LanguageSwitcher };
